import CheckboxCellColumn from "@/components/functionals/CheckboxCellColumn.vue";
import ColumnPaymentChange from "@/views/modules/projects/components/ColumnPaymentChange.vue";
import CheckedForColumnsVue from "@/components/functionals/checkedForColumns.vue";
import { formatDate } from "@/utils";

export const GetProjectExpiredAccsWithoutExecution = async function (thiss) {
  let tableData = [];
  if (
    //thiss.currentUser.Roles.some((e) => e.Id === 30 || e.Id === 37)
    thiss.currentUser.PositionID == 110 ||
    thiss.currentUser.PositionID == 82 ||
    thiss.currentUser.PositionID == 16
  ) {
    await thiss.$http
      .get("/api/Proyects/GetProjectCashFlowExpiredDetails")
      .then((result) => {
        //console.log("cuentas de ingresos sin ejecutar", result);
        tableData = result.data;
      })
      .catch((err) => {
        console.error("Error al consultar las cuentas sin ejecutar: ", err);
      })
      .finally(() => {});
  } else {
    tableData = [];
  }
  return tableData;
};

export const ProjectExpiredAccsWithoutExecutionColumns = (thiss) => [
  {
    prop: "ProveedorCode",
    label: "Código Prov.",
    minWidth: 95,
    sortable: true
    //condition: (row) => console.log("row in ProveedorCode",row)
  },
  {
    prop: "ProveedorName",
    label: "Nombre Proveedor",
    minWidth: 140,
    sortable: true
    //condition: (row) => console.log("row in ProveedorName",row)
  },
  {
    prop: "Description",
    label: "Nota",
    minWidth: 200,
    sortable: true
  },
  {
    prop: "PostinDate",
    label: "Fecha",
    minWidth: 100,
    sortable: true,
    formatter: handlePostinDateFormat
  },
  {
    prop: "Amount",
    label: "Monto",
    minWidth: 100,
    sortable: true,
    formatter: formatMount
  },
  {
    prop: "Excetuted",
    label: "Ejecutado",
    type: "selection",
    minWidth: 100,
    formatter: CheckboxCellColumn,
    attrs: {
      openDrawer: thiss.$refs.dialogLocker.handleStatusToggle
    }
  },
  {
    minWidth: 100,
    formatter: ColumnPaymentChange,
    attrs: {
      changeProjectLineDate: thiss.$refs.dialogLocker.changeProjectLineDate
    }
  },
  {
    prop: "Type",
    label: "Tipo de cuenta",
    minWidth: 100,
    sortable: true,
    formatter: CheckedForColumnsVue
  }
];

export const ProjectExpiredAccsWithoutExecutionActions = [
  {
    icon: "el-icon-s-ticket",
    label: "Activar Solicitud de Pago",
    command: "activate-internal-request",

    condition: (row) => row.Type == 0
    //console.log("row in action condition: ", row)
  }
];

function handlePostinDateFormat(row) {
  return formatDate(row.PostinDate, "DD/MM/YYYY");
}

function formatMount(mount) {
  const formatter = new Intl.NumberFormat("es-DO", {
    stlye: "currency",
    currency: "DOP"
  });
  return formatter.format(mount.Amount);
}
